import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-phone\"><defs><style type=\"text/css\"></style></defs><path d=\"M443.2 580.8c-88.7-88.6-173.5-191.3-132.8-231.9 58.1-58.1 108.7-93.9 5.8-222-103-128.2-171.7-29.8-228 26.5-64.9 65-3.4 307.1 235.9 546.5 239.3 239.3 481.5 300.9 546.5 235.9 56.3-56.3 154.7-124.9 26.6-227.9s-163.9-52.4-222 5.8c-40.7 40.5-143.3-44.3-232-132.9z\" fill=\"\" p-id=\"2042\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol